export interface MovimentacaoSocietaria {
  id: number;
  dataMudancaEntidade:string;
  statusMudancaEntidade: StatusMudancaEntidade;
  tipoMudancaEntidade: TipoMudancaEntidade;
  exigeNotificacao: boolean;
  justificativaMudanca: string;
  entidadesEnvolvidas: EntidadesEnvolvida[];
  dataStatusMudanca: string;
  dataCadastro: string;
  usuarioCadastro: string;
  dataUltimaAtualizacao: string;
  usuarioUltimaAtualizacao: string;
}

interface EntidadesEnvolvida {
  id: number;
  entidade: Entidade;
  novoStatusEntidade: NovoStatusEntidade;
  atualGrupoEconomico: AtualGrupoEconomico;
  novoGrupoEconomico: AtualGrupoEconomico;
  razaoSocialAnterior: string;
  novaRazaoSocial: string;
  tipoEnvolvimento: TipoEnvolvimento;
  dataCadastro: string;
  deveNotificar: boolean;
  emails: string[];
}

interface TipoEnvolvimento {
  id: number;
  nomeTipoEnvolvimento: string;
  dataCadastro: string;
  dataInativo: string;
}

interface AtualGrupoEconomico {
  id: number;
  nomeGrupoEconomico: string;
  dataCadastro: string;
  dataInativo: string;
}

interface NovoStatusEntidade {
  id: number;
  nomeStatusEntidade: string;
  dataCadastro: string;
  dataInativo: string;
}

interface Entidade {
  id: number;
  tipoEntidadeId: number;
  nomeRazaoSocial: string;
  nomeFantasia: string;
  grupoEconomicoId: number;
  cnpj: string;
  representacaoId: number;
  tipoRelacaoId: number;
  entidadeSuperiorIds: number[];
  qtdAnosMandato: number;
  tipoComissaoId: number;
  flagComissaoPermanente: boolean;
  flagEntidadeSigilosa: boolean;
  entidadeAdministradoraId: number;
  pessoaAdministradoraId: number;
  codigoSusep: string;
  codigoAns: string;
  flagEmpresaEstrangeira: boolean;
  numRegistroEmpresaEstrangeira: string;
  entidadeResponsavelCadastramentoId: number;
  statusEntidadeId: number;
  dataStatusEntidade: string;
  dataCadastro: string;
  usuarioCadastroId: number;
  dataUltimaAtualizacao: string;
  usuarioUltimaAtualizacaoId: number;
  entidadeContatos: EntidadeContato[];
  entidadeCargos: EntidadeCargo[];
  entidadeDocumentos: EntidadeDocumento[];
  entidadeObservacoes: EntidadeObservacoe[];
  entidadeEnvolvidas: string[];
  entidadeGrupos: EntidadeGrupo[];
  dataControleAtualizacao: string;
}

interface EntidadeGrupo {
  id: number;
  idEntidade: number;
  idGrupo: number;
}

interface EntidadeObservacoe {
  id: number;
  dataCadastro: string;
  dataObservacao: string;
  textoObservacao: string;
}

interface EntidadeDocumento {
  id: number;
  nomeDocumento: string;
  tipoDocumentoId: number;
  arquivoId: number;
  dataCadastro: string;
  dataInativo: string;
}

interface EntidadeCargo {
  id: number;
  nomeCargo: string;
  cargoReferencia: CargoReferencia;
  cargoReferenciaId: number;
  nivelHierarquico: number;
  dataInicioCargo: string;
  dataFimCargo: string;
  dataCadastro: string;
  dataInativo: string;
}

interface CargoReferencia {
  id: number;
  nomeCargoReferencia: string;
  nivelHierarquico: number;
  dataCadastro: string;
  dataInativo: string;
}

interface EntidadeContato {
  id: number;
  tipoContato: TipoContato;
  email: string;
  telefone: string;
  ddi: string;
  ramal: string;
  enderecoLogradouro: string;
  enderecoComplemento: string;
  enderecoNumero: string;
  enderecoBairro: string;
  enderecoMunicipio: EnderecoMunicipio;
  enderecoCep: string;
  flagPrincipal: boolean;
  dataCadastro: string;
  dataInativo: string;
  enderecoUf: Uf;
  pais: Pais;
  siteUrl: string;
}

interface Pais {
  id: number;
  nome: string;
  codigoISO: string;
}

interface EnderecoMunicipio {
  id: number;
  nome: string;
  uf: Uf;
  codigoIBGE: string;
}

interface Uf {
  id: number;
  nome: string;
  sigla: string;
  codigoIBGE: string;
}

interface TipoContato {
  id: number;
  nomeTipoContato: string;
  dataCadastro: string;
  dataInativo: string;
}

interface TipoMudancaEntidade {
  id: number;
  nomeTipoMudancaEntidade: string;
  dataCadastro: string;
  dataInativo: string;
}

interface StatusMudancaEntidade {
  id: number;
  nomeStatusMudancaEntidade: string;
  dataCadastro: string;
  dataInativo: string;
}





export interface FiltroMudancaSocietaria {
  statusMudancaEntidade: StatusMudancaEntidade;
  idMudanca: number;
  nomeParticipantes: string;
  tipoMudancaEntidade: TipoMudancaEntidade;
  dataDe: string;
  dataAte: string;
}

interface TipoMudancaEntidade {
  id: number;
  nomeTipoMudancaEntidade: string;
  dataCadastro: string;
  dataInativo: string;
}

interface StatusMudancaEntidade {
  id: number;
  nomeStatusMudancaEntidade: string;
  dataCadastro: string;
  dataInativo: string;
}


export interface ResultadoMovimentacaoSocietaria {
  id: number;
  dataMudanca: string;
  tipoMudancaEntidade: TipoMudancaEntidade;
}

export enum TipoEntidadesEnvolvidasEnum {
  Unica = 1,
  Varias = 2
}
